import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MSAccessTokenResponse } from '../models/ms-access-token.interface';
import { PowerBITokenResponse } from '../models/powerbi-token.interface';
import { environment } from 'src/environments/environment';
import { API } from 'src/app/providers/services/api/api.const';
import { ApiService } from 'src/app/providers/services/api/api.service';
import { KpiData } from '../models/kpi.interface';

@Injectable({
  providedIn: 'root',
})
export class PowerBiHttpService extends ApiService {
  endpoint = API.CUSTOMER.KPIS;


  getKpis(): Observable<KpiData> {
    return this.get<KpiData>({
      operation: 'getKpis',
      url: this.endpoint.getKpis(),
    });

  }
  /*   getMicrosoftAccessToken(): Observable<MSAccessTokenResponse> {
      return this.http.get<MSAccessTokenResponse>(`https://digitalconsulting-api-dev.azure-api.net/ms-login`);
    }
  
    getPowerBiEmbedToken(): Observable<PowerBITokenResponse> {
      const body = {
        accessLevel: 'View',
        allowSaveAs: 'false',
      };
  
      return this.http.post<PowerBITokenResponse>(
        `https://api.powerbi.com/v1.0/myOrg/groups/${environment.powerbi.groupId}/reports/${environment.powerbi.reportId}/GenerateToken`,
        body,
      );
    } */
}
